import { createContext, Dispatch, useContext, useReducer } from "react";
import { StoreActionMap } from "./actions";
import { storeReducer } from "./reducer";

export const initialState = {
    mode: localStorage.getItem('mode') as 'dark' | 'light' || (window.matchMedia("(prefers-color-scheme: dark)").matches ? 'dark' : 'light')  as 'dark' | 'light',
    sideBar: false,
    mobile: window.innerWidth < 1024
};

export type Store = typeof initialState;

export type StoreContextType = {
    state: Store;
    dispatch: Dispatch<StoreActionMap>;
};

export const StoreContext = createContext<StoreContextType>({
    state: initialState,
    dispatch: () => undefined
});

export const useStoreContext = () => useContext(StoreContext);
export const useStoreReducer = () => useReducer(storeReducer, initialState);